import {
  APPSFLYER_BANNER_KEY_DEV,
  APPSFLYER_BANNER_KEY_PROD,
  APPSFLYER_BANNER_KEY_STAGING,
} from "settings";

type AppsFlyerCommand = [timestamp: number, ...args: unknown[]];

interface AppsFlyerSDK {
  (...args: unknown[]): void;
  q?: AppsFlyerCommand[];
  id?: {
    banners?: {
      key: string;
    };
  };
  plugins?: Record<string, unknown>;
}

interface InitAppsFlyerBannerParams {
  delayMs?: number;
  configOverrides?: Record<string, unknown>;
}

export function initAppsFlyerBanner({
  delayMs = 0,
  configOverrides = {},
}: InitAppsFlyerBannerParams = {}): void {
  const alreadyLoaded = typeof window.AF === "function" && window.AF.id != null;
  const bannerKey =
    import.meta.env.MODE === "development"
      ? APPSFLYER_BANNER_KEY_DEV
      : import.meta.env.MODE === "staging"
        ? APPSFLYER_BANNER_KEY_STAGING
        : APPSFLYER_BANNER_KEY_PROD;

  if (alreadyLoaded) {
    setTimeout(() => {
      window.AF?.("banners", "showBanner", configOverrides);
    }, delayMs);
    return;
  }

  window.AppsFlyerSdkObject = "AF";

  window.AF = ((...args: unknown[]) => {
    const af = window.AF as AppsFlyerSDK;
    af.q = af.q ?? [];
    af.q.push([Date.now(), ...args]);
  }) as AppsFlyerSDK;

  window.AF.id = {
    banners: {
      key: bannerKey,
    },
  };

  window.AF.plugins = {};

  const script = document.createElement("script");
  script.src = "https://websdk.appsflyer.com?st=banners";
  script.async = true;

  script.onload = () => {
    setTimeout(() => {
      window.AF?.("banners", "showBanner", configOverrides);
    }, delayMs);
  };

  document.head.appendChild(script);
}
